import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Phone, ArrowLeft } from 'lucide-react';
import { PHONES, CONTACT } from '../content';
import { SEOHead } from '../components/SEOHead';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <main data-testid="not-found-page" style={{ background: 'var(--bg)', paddingTop: 86, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Sayfa Bulunamadı — 7/24 Lastik Kocaeli</title>
      </Helmet>

      <div className="wrap" style={{ textAlign: 'center', padding: '3rem 1.5rem' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .5 }}
        >
          <div style={{
            fontSize: 'clamp(5rem, 15vw, 10rem)',
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 900,
            color: 'var(--red)',
            lineHeight: 1,
            letterSpacing: '-.06em',
            opacity: .15,
          }}>
            404
          </div>

          <h1 style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 800,
            fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
            color: 'var(--text)',
            lineHeight: 1.15,
            marginTop: '-1rem',
            marginBottom: '1rem',
          }}>
            Sayfa Bulunamadı
          </h1>

          <p style={{
            color: 'var(--text2)',
            fontSize: 'clamp(.875rem, 1.5vw, 1rem)',
            lineHeight: 1.7,
            maxWidth: 480,
            margin: '0 auto 2.5rem',
          }}>
            Aradığınız sayfa taşınmış veya kaldırılmış olabilir. Ana sayfaya dönebilir ya da yolda kaldıysanız bizi arayabilirsiniz.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.75rem', justifyContent: 'center' }}>
            <Link
              to="/"
              data-testid="404-home-link"
              className="btn btn-primary"
              style={{ gap: '.5rem' }}
            >
              <Home size={15} /> Ana Sayfa
            </Link>
            <a
              href={PHONES.main_tel}
              data-testid="404-call-cta"
              className="btn btn-secondary num ring"
              style={{ gap: '.5rem' }}
            >
              <Phone size={15} /> {PHONES.main}
            </a>
          </div>
        </motion.div>
      </div>
    </main>
  );
}
